/* Kōbu landing page — flavor tabs, plan toggle, quantity, buy total */
(function () {
  if (window.KobuLandingPageInit) return;
  window.KobuLandingPageInit = true;

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0);

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount / 100);
    } catch (error) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  function initLanding(root) {
    if (!root || root.dataset.kobuLpInit === '1') return;
    root.dataset.kobuLpInit = '1';
    var currency = root.getAttribute('data-currency') || 'USD';

    // Flavor swap
    var thumbs = root.querySelectorAll('[data-flavor-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-flavor-thumb');
        root.querySelectorAll('[data-flavor-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === btn);
        });
        root.querySelectorAll('[data-flavor]').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-flavor') === id);
        });
        root.querySelectorAll('[data-flavor-info]').forEach(function (info) {
          info.classList.toggle('is-active', info.getAttribute('data-flavor-info') === id);
        });
      });
    });

    // Plan + quantity per flavor panel
    root.querySelectorAll('[data-flavor-info]').forEach(function (panel) {
      var plans = panel.querySelectorAll('.kobu-lp__plan');
      var qty = 1;
      var qtyValue = panel.querySelector('[data-qty-value]');
      var buyBtn = panel.querySelector('[data-buy-btn]');
      var buyTotal = panel.querySelector('[data-buy-total]');
      var cartError = panel.querySelector('[data-cart-error]');

      function activePlan() {
        var active = panel.querySelector('.kobu-lp__plan.is-active');
        return active || plans[0];
      }
      function setError(message) {
        if (!cartError) return;
        cartError.textContent = message || '';
        cartError.hidden = !message;
      }
      function updateTotal() {
        var plan = activePlan();
        var cents = parseInt(plan.getAttribute('data-price-cents'), 10) || 0;
        var totalCents = cents * qty;

        if (buyTotal) buyTotal.textContent = formatMoney(totalCents, currency);
        if (buyBtn) {
          buyBtn.setAttribute('data-base-price-cents', String(cents));
          buyBtn.setAttribute('data-selling-plan-id', plan.getAttribute('data-selling-plan-id') || '');
        }
      }
      function addToCart() {
        if (!buyBtn || buyBtn.disabled || buyBtn.getAttribute('aria-disabled') === 'true') return;

        var variantId = buyBtn.getAttribute('data-variant-id');
        var sellingPlanId = buyBtn.getAttribute('data-selling-plan-id');
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        setError('');

        if (!variantId) {
          setError('Please select a product first.');
          return;
        }

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', String(qty));
        if (sellingPlanId) formData.append('selling_plan', sellingPlanId);

        Promise.resolve(
          window.KobuCartGroupGuard?.prepareAdd(
            formData,
            window.location.pathname.includes('/pages/kobu-content-creator') ? 'content-creator' : undefined
          )
        )
          .then(function () {
            if (cart) {
              formData.append(
                'sections',
                cart.getSectionsToRender().map(function (section) { return section.id; })
              );
              formData.append('sections_url', window.location.pathname);
              if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
            }

            buyBtn.setAttribute('aria-disabled', 'true');
            buyBtn.classList.add('is-loading');

            return fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/javascript'
              },
              body: formData
            });
          })
          .then(function (response) { return response.json(); })
          .then(function (response) {
            if (response.status) {
              setError(response.description || response.message || 'Unable to add this item to cart.');
              return;
            }

            if (cart && cart.renderContents) {
              cart.renderContents(response);
            }
          })
          .catch(function () {
            setError('Unable to add this item to cart.');
          })
          .finally(function () {
            buyBtn.classList.remove('is-loading');
            buyBtn.removeAttribute('aria-disabled');
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          });
      }
      plans.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
          plans.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          updateTotal();
        });
      });

      var dec = panel.querySelector('[data-qty-dec]');
      var inc = panel.querySelector('[data-qty-inc]');
      if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); if (qtyValue) qtyValue.textContent = qty; updateTotal(); });
      if (inc) inc.addEventListener('click', function () { qty = qty + 1; if (qtyValue) qtyValue.textContent = qty; updateTotal(); });
      if (buyBtn) buyBtn.addEventListener('click', addToCart);

      updateTotal();
    });
  }

  function initFaq(faq) {
    if (!faq || faq.dataset.kobuFaqInit === '1') return;
    faq.dataset.kobuFaqInit = '1';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = faq.querySelectorAll('.kobu-lp__faq-item');

    function setAnswerState(details, summary, answer) {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      answer.style.height = details.open ? 'auto' : '0px';
    }

    function openItem(details, summary, answer) {
      if (reduceMotion) {
        details.open = true;
        setAnswerState(details, summary, answer);
        return;
      }

      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
      answer.style.height = '0px';
      answer.offsetHeight;
      details.dataset.animating = '1';
      answer.style.height = answer.scrollHeight + 'px';

      answer.addEventListener('transitionend', function () {
        details.dataset.animating = '';
        answer.style.height = 'auto';
      }, { once: true });
    }

    function closeItem(details, summary, answer) {
      if (reduceMotion) {
        details.open = false;
        setAnswerState(details, summary, answer);
        return;
      }

      summary.setAttribute('aria-expanded', 'false');
      answer.style.height = answer.scrollHeight + 'px';
      answer.offsetHeight;
      details.dataset.animating = '1';
      answer.style.height = '0px';

      answer.addEventListener('transitionend', function () {
        details.open = false;
        details.dataset.animating = '';
      }, { once: true });
    }

    items.forEach(function (details) {
      var summary = details.querySelector('.kobu-lp__faq-summary');
      var answer = details.querySelector('.kobu-lp__faq-answer');
      if (!summary || !answer) return;

      setAnswerState(details, summary, answer);
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.dataset.animating === '1') return;

        if (details.open) {
          closeItem(details, summary, answer);
        } else {
          openItem(details, summary, answer);
        }
      });
    });
  }

  document.querySelectorAll('[data-kobu-lp]').forEach(initLanding);
  document.querySelectorAll('[data-faq]').forEach(initFaq);
  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-kobu-lp]');
    if (el) initLanding(el);
    e.target.querySelectorAll('[data-faq]').forEach(initFaq);
  });
})();
